import React from 'react';
import { QUEUE_STATUSES, DELIVERY_STATUSES } from './notificationTypes';

const StatCard = ({ label, value, badge }) => (
  <div className="bg-white rounded-xl border border-gray-200 p-4">
    <span className={`inline-flex px-2 py-0.5 rounded-full text-xs font-medium ${badge}`}>
      {label}
    </span>
    <div className="mt-2 text-2xl font-bold text-gray-900 tabular-nums">{value ?? '—'}</div>
  </div>
);

/**
 * Tarjetas con el conteo por estado de la cola y por estado de entrega.
 */
const NotificationsStats = ({ stats, loading }) => {
  const byStatus = stats?.byStatus || {};
  const byDelivery = stats?.byDeliveryStatus || {};
  const show = (v) => (loading && !stats ? '…' : v);

  return (
    <div className="space-y-4">
      <div>
        <h2 className="text-sm font-semibold text-gray-700 mb-2">
          Estado en la cola (total: {show(byStatus.total)})
        </h2>
        <div className="grid grid-cols-2 md:grid-cols-6 gap-3">
          {QUEUE_STATUSES.map((s) => (
            <StatCard key={s.value} label={s.label} badge={s.badge} value={show(byStatus[s.value])} />
          ))}
        </div>
      </div>

      <div>
        <h2 className="text-sm font-semibold text-gray-700 mb-2">Estado de entrega (según Meta)</h2>
        <div className="grid grid-cols-2 md:grid-cols-6 gap-3">
          {DELIVERY_STATUSES.map((s) => (
            <StatCard key={s.value} label={s.label} badge={s.badge} value={show(byDelivery[s.value])} />
          ))}
          <StatCard
            label="Sin confirmar"
            badge="bg-gray-50 text-gray-500"
            value={show(byDelivery.none)}
          />
        </div>
      </div>
    </div>
  );
};

export default NotificationsStats;
